import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import 'antd/dist/reset.css';
import { App } from 'antd';
import BackOffice from './presentation/BackOffice';
import RootProviders from './presentation/contexts/RootProviders';
import { initSentry } from './infrastructure/sentry';

const SERVER_ENV = import.meta.env.APP_ENV || process.env.NODE_ENV || 'development' // Fall back is dev;
initSentry(SERVER_ENV);

const rootElement = document.getElementById('root') as HTMLElement;
ReactDOM.createRoot(rootElement).render(
  <Sentry.ErrorBoundary>
    <RootProviders>
      <App>
        <BrowserRouter>
          <BackOffice />
        </BrowserRouter>
      </App>
    </RootProviders>
  </Sentry.ErrorBoundary>
);
